"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7724],{

/***/ 37724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ home_page_DesktopApp; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/features/home-page/styled.ts
var styled = __webpack_require__(24529);
;// CONCATENATED MODULE: ./src/features/home-page/DesktopApp/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  align-items: center;\n  @media ",
        " {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 40px;\n  flex-direction: column;\n  span {\n    max-width: 488px;\n    font-size: 18px;\n    line-height: 26px;\n    color: #575757;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 25.5px;\n\n  @media ",
        " {\n    font-size: 48px;\n    line-height: 60px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  align-items: flex-start;\n  .green {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  a {\n    color: ",
        ";\n    font-size: 18px;\n    line-height: 26px;\n    font-weight: 700;\n    width: 344px;\n    display: flex;\n    border: 1px solid;\n    height: 44px;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n  }\n  img {\n    background: #3b3b3b;\n    border-radius: 6px;\n    max-width: 100vw;\n  }\n  @media ",
        " {\n    img {\n      max-width: 100vw;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var Text = ui/* Common.Text */.Gn.Text, Flex = ui/* Common.Flex */.Gn.Flex;
var SectionWrapper = (0,styled_components_browser_esm["default"])(styled/* Wrapper */.im).withConfig({
    componentId: "sc-32b3121-0"
})(_templateObject(), ui/* device.tablet */.Uh.tablet);
var LeftSection = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-32b3121-1"
})(_templateObject1());
var Title = (0,styled_components_browser_esm["default"])(Text).attrs({
    as: "h3",
    family: "bold",
    align: "center",
    mb: "20px"
}).withConfig({
    componentId: "sc-32b3121-2"
})(_templateObject2(), ui/* device.tablet */.Uh.tablet);
var LeftTitle = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-32b3121-3"
})(_templateObject3(), ui/* color.primary */.$_.primary);
var ButtonsWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-32b3121-4"
})(_templateObject4(), ui/* color.primary */.$_.primary, ui/* device.tablet */.Uh.tablet);


// EXTERNAL MODULE: ./src/features/download/DownloadButtons.tsx
var DownloadButtons = __webpack_require__(62486);
;// CONCATENATED MODULE: ./src/features/home-page/DesktopApp/index.tsx






function DesktopApp() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
        offset: {
            top: 140,
            bottom: 140
        },
        partialVisibility: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftTitle, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    children: "Stockbit Tersedia versi "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    className: "green",
                                    children: "Desktop App"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "content",
                            children: "Pengalaman trading lebih Profesional dengan Aplikasi Saham versi Desktop untuk MacOS dan Windows."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonsWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/desktop",
                                    className: "explore",
                                    children: "Mulai Jelajahi"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadButtons/* default */.Z, {
                                    source: "Stockbit Main Page"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/images/desktop-monitor.svg"
                })
            ]
        })
    });
}
/* harmony default export */ var home_page_DesktopApp = (DesktopApp);


/***/ }),

/***/ 24529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NZ": function() { return /* binding */ SectionTitle; },
/* harmony export */   "Vq": function() { return /* binding */ SectionSubtitle; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var _keyframes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16681);
/* eslint-disable indent */ /* eslint-disable space-infix-ops */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 50px 25px;\n  width: 100%;\n  max-width: 1300px;\n\n  @media ",
        " {\n    padding: 50px 30px;\n  }\n\n  @media ",
        " {\n    padding: 50px 0;\n    width: calc(100% - 150px);\n  }\n\n  // animations\n  .scaleUpX {\n    transform: scale(0.9);\n  }\n\n  .fadeInRightX,\n  .fromRightX,\n  .fadeInLeftlongX,\n  .fadeInLeftBorderX,\n  .fadeInLeftX2,\n  .fadeInLeftX,\n  .fadeInX,\n  .fadeInTopX,\n  .fadeInDownX,\n  .scaleUpX {\n    opacity: 0;\n  }\n\n  .fadeInLeftBorderX.on,\n  .fadeInLeftX.on,\n  .fadeInX.on {\n    opacity: 1;\n  }\n\n  .fadeIn {\n    animation-duration: 1s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fromRight {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fadeInRight {\n    animation-duration: 1s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fadeInLeft {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fadeInLeft2 {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n    animation-delay: 0.3s;\n  }\n\n  .fadeInTopX {\n  }\n\n  .fadeInTop {\n    animation-duration: 0.5s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n    transform: translate3d(0, -50px, 0);\n  }\n\n  .fadeInDown {\n    animation-duration: 0.5s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n    transform: translate3d(0, -50px, 0);\n  }\n\n  .fromRightP:nth-child(1) .fromRight {\n    animation-delay: 0.2s;\n  }\n\n  .fromRightP:nth-child(2) .fromRight {\n    animation-delay: 0.35s;\n  }\n\n  .fromRightP:nth-child(3) .fromRight {\n    animation-delay: 0.5s;\n  }\n\n  .fromRightP:nth-child(4) .fromRight {\n    animation-delay: 0.65s;\n  }\n\n  .fromRightP:nth-child(5) .fromRight {\n    animation-delay: 0.8s;\n  }\n\n  .fromRightP:nth-child(6) .fromRight {\n    animation-delay: 0.95s;\n  }\n\n  .scaleUp {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 36px;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 6.5vh;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 17px;\n  margin-top: 5vh;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 18px;\n  }\n\n  @media ",
        " {\n    font-size: 19px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).attrs({
    direction: "column",
    m: "auto",
    as: "section"
}).withConfig({
    componentId: "sc-a748cd86-0"
})(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.laptop */ .Uh.laptop, _keyframes__WEBPACK_IMPORTED_MODULE_2__/* .fadeIn */ .Ji, _keyframes__WEBPACK_IMPORTED_MODULE_2__/* .fromRight */ .hb, _keyframes__WEBPACK_IMPORTED_MODULE_2__/* .fadeInRight */ .ER, _keyframes__WEBPACK_IMPORTED_MODULE_2__/* .fadeInLeft */ .O2, _keyframes__WEBPACK_IMPORTED_MODULE_2__/* .fadeInLeft */ .O2, _keyframes__WEBPACK_IMPORTED_MODULE_2__/* .fadeInTop */ .E_, _keyframes__WEBPACK_IMPORTED_MODULE_2__/* .fadeInDown */ .d7, _keyframes__WEBPACK_IMPORTED_MODULE_2__/* .scaleUp */ .wK);
var SectionTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Text).attrs({
    as: "h1",
    family: "bold",
    height: 1,
    m: "0px"
}).withConfig({
    componentId: "sc-a748cd86-1"
})(_templateObject1(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.laptop */ .Uh.laptop);
var SectionSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Text).attrs({
    family: "light",
    height: 1.5
}).withConfig({
    componentId: "sc-a748cd86-2"
})(_templateObject2(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.laptop */ .Uh.laptop);



/***/ })

}]);